/**
 * Хеширование паролей для локального (демо) режима.
 *
 * ВАЖНО: это временное решение на период, пока нет сервера. Пароль хешируется
 * SHA-256 с солью и хранится в IndexedDB устройства — этого достаточно, чтобы
 * не держать пароль открытым текстом, но недостаточно для защиты от
 * целенаправленного перебора.
 *
 * При подключении реального сервера проверка пароля переезжает на бэкенд
 * (bcrypt/argon2 + HTTPS), а этот модуль остаётся только для офлайн-демо.
 * См. `src/features/auth/api/auth-provider.ts` — там точка замены.
 */

const SALT = 'kairo.v1';

export async function hashPassword(password: string): Promise<string> {
  const data = new TextEncoder().encode(`${SALT}:${password}`);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export async function verifyPassword(password: string, hash: string): Promise<boolean> {
  const computed = await hashPassword(password);
  // Сравнение постоянного времени: не даём измерить, где именно разошлись хеши.
  if (computed.length !== hash.length) return false;
  let diff = 0;
  for (let i = 0; i < computed.length; i += 1) {
    diff |= computed.charCodeAt(i) ^ hash.charCodeAt(i);
  }
  return diff === 0;
}
